// src/components/PrivateRoute.js
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { logger } from "../utils/logger";

export default function PrivateRoute({ children }) {
  const { currentUser, ready } = useAuth();
  const location = useLocation();

  if (!ready) return <div>Loading...</div>;

  if (!currentUser) {
    logger.log("🚫 PrivateRoute: Not logged in → redirect to /login");
    // Pass the current location as return URL so user can be redirected back after login
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  logger.log("✅ PrivateRoute: Access granted");
  return children;
}
